<template>
    <div>
        <material-card color="green">
            <v-flex slot="header">
                <v-layout row>
                    <span
                        class="subheading font-weight-light mr-3"
                        style="align-self: center"
                        >Coupons</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0"
                        small
                        @click="openNewCouponDialog()"
                        >New Coupon
                    </v-btn>
                </v-layout>
            </v-flex>
            <div v-for="(coupon, index) in coupons" class="mt-2">
                <v-layout row justify-space-between class="mx-0">
                    <v-layout row class="mt-2 mb-0 px-3">
                        <div class="font-weight-medium width-200">
                            Coupon #
                        </div>
                        <div>{{ coupon.couponNum }}</div>
                    </v-layout>
                    <v-btn
                        class="my-0"
                        @click="openPrintCouponDialog(coupon)"
                        flat
                        icon
                        color="info"
                    >
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-btn
                        class="my-0"
                        v-if="!coupon.editing"
                        @click="editCoupon(coupon)"
                        flat
                        icon
                        color="success"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </v-layout>
                <v-layout row class="mb-2 px-3" v-if="!coupon.editing">
                    <div class="font-weight-medium width-200">
                        Amount
                    </div>
                    <div>${{ coupon.amount }}</div>
                </v-layout>
                <v-layout row class="mb-2 px-3" v-if="coupon.kids">
                    <div class="font-weight-medium width-200">
                        Kids
                    </div>
                    <div>
                        {{ coupon.kids }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2 px-3">
                    <div class="font-weight-medium width-200">
                        Coupon Type
                    </div>
                    <div>
                        Matzo Coupon
                    </div>
                </v-layout>
                <v-layout
                    row
                    class="mb-2 px-3"
                    v-if="coupon.note && !coupon.editing"
                >
                    <div class="font-weight-medium width-200">
                        Note
                    </div>
                    <div>
                        {{ coupon.note }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2 px-3" v-if="coupon.createdBy">
                    <div class="font-weight-medium width-200">
                        Created By
                    </div>
                    <div>
                        {{ coupon.createdBy }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2 px-3" v-if="coupon.createdAt">
                    <div class="font-weight-medium width-200">
                        Created At
                    </div>
                    <div>
                        {{ coupon.createdAt | time }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2 px-3" v-if="coupon.updatedBy">
                    <div class="font-weight-medium width-200">
                        Updated By
                    </div>
                    <div>
                        {{ coupon.updatedBy }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2 px-3" v-if="coupon.updatedAt">
                    <div class="font-weight-medium width-200">
                        Updated At
                    </div>
                    <div>
                        {{ coupon.updatedAt | time }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2 px-3" v-if="coupon.printedAt">
                    <div class="font-weight-medium width-200">
                        Printed At
                    </div>
                    <div>
                        {{ coupon.printedAt | time }}
                    </div>
                </v-layout>
                <div v-if="coupon.editing" class="mt-2 px-1">
                    <v-text-field
                        label="Amount"
                        v-model="coupon.copy.amount"
                        prefix="$"
                        type="number"
                        ref="amount"
                        :rules="[rules.required]"
                    >
                    </v-text-field>
                    <v-text-field
                        label="Note"
                        ref="note"
                        v-model="coupon.copy.note"
                        :rules="[rules.required]"
                    >
                    </v-text-field>
                </div>
                <v-layout row class="my-3 mr-4" v-if="coupon.editing">
                    <v-layout row>
                        <v-spacer></v-spacer>
                        <v-btn
                            class="small-button mr-1"
                            color="default"
                            @click="rollbackCoupon(coupon)"
                            small
                            dark
                            >Cancel</v-btn
                        >
                        <v-btn
                            class="small-button"
                            color="success"
                            small
                            :loading="processing"
                            @click="saveCoupon(coupon)"
                            >Save</v-btn
                        >
                    </v-layout>
                </v-layout>
                <v-divider
                    class="my-1"
                    v-if="index + 1 < coupons.length"
                ></v-divider>
            </div>
        </material-card>
        <v-dialog v-model="newCouponDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">New Coupon</v-card-title>
                <v-text-field
                    label="Amount"
                    class="px-2"
                    v-model="newCoupon.amount"
                    prefix="$"
                    type="number"
                    ref="newCouponAmount"
                    :rules="[rules.required]"
                >
                </v-text-field>
                <v-text-field
                    label="Kids"
                    class="px-2"
                    v-model="newCoupon.kids"
                    type="number"
                    ref="newCouponKids"
                    :rules="[rules.required]"
                >
                </v-text-field>
                <v-text-field
                    label="Note"
                    class="px-2"
                    ref="newCouponNote"
                    v-model="newCoupon.note"
                    :rules="[rules.required]"
                >
                </v-text-field>
                <v-card-actions class="mr-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="newCouponDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveCoupon(newCoupon, true)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="printCouponDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Print Coupon</v-card-title>
                <v-text-field
                    label="Note"
                    class="px-3"
                    ref="printCouponNote"
                    v-model="printCouponNote"
                    :rules="[rules.required]"
                >
                </v-text-field>
                <v-card-actions class="mr-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="printCouponDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" :loading="processing" @click="print">
                        Print
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { getDomain } from "../../utils/helpers.js";

export default {
    props: {
        coupons: Array,
        account: Object,
        reloadCoupons: Function,
    },
    data() {
        return {
            newCouponDialog: false,
            newCoupon: "",
            processing: false,
            printCouponNote: "",
            printCouponDialog: false,
            couponToPrint: "",

            rules: {
                required: (v) => {
                    return !!v || "Required";
                },
            },
        };
    },
    async created() {},
    computed: {},
    methods: {
        openNewCouponDialog() {
            this.newCoupon = {
                couponID: 0,
                couponTypeID: 1,
                accountID: this.account.accountID,
                amount: "",
                kids: 1,
                note: "",
            };

            this.newCouponDialog = true;

            this.$refs.newCouponAmount.resetValidation();
            this.$refs.newCouponKids.resetValidation();
            this.$refs.newCouponNote.resetValidation();
        },
        openPrintCouponDialog(coupon) {
            this.couponToPrint = coupon;
            this.printCouponNote = coupon.note;

            this.printCouponDialog = true;

            this.$refs.printCouponNote.resetValidation();
        },
        editCoupon(coupon) {
            coupon.editing = true;
            coupon.copy = JSON.parse(JSON.stringify(coupon));
        },
        rollbackCoupon(coupon) {
            coupon.editing = false;
        },
        print() {
            if (!this.$refs.printCouponNote.validate(true)) return;

            window.location =
                getDomain() +
                "/api/accounts/downloadMatzoCoupons?accountID=" +
                this.account.accountID +
                "&note=" +
                this.printCouponNote +
                "&user=" +
                this.$store.state.authentication.user;

            setTimeout(this.reloadCoupons, 1000);

            this.printCouponDialog = false;
        },
        async saveCoupon(coupon, isNew = false) {
            if (isNew) {
                if (
                    !this.$refs.newCouponAmount.validate(true) ||
                    !this.$refs.newCouponNote.validate(true) ||
                    !this.$refs.newCouponKids.validate(true)
                )
                    return;
            } else {
                const index = this.coupons.indexOf(coupon);

                if (
                    !this.$refs.amount[index].validate(true) ||
                    !this.$refs.note[index].validate(true)
                )
                    return;
            }

            try {
                this.processing = true;

                await this.$http.post("api/accounts/saveMatzoCoupon", {
                    couponID: coupon.couponID,
                    couponTypeID: 1,
                    accountID: coupon.accountID,
                    amount: isNew ? coupon.amount : coupon.copy.amount,
                    kids: isNew ? coupon.kids : coupon.copy.kids,
                    note: isNew ? coupon.note : coupon.copy.note,
                    couponNum: coupon.couponNum,
                    createdBy:
                        coupon.createdBy ||
                        this.$store.state.authentication.user,
                    updatedBy: coupon.couponID
                        ? this.$store.state.authentication.user
                        : "",
                });

                this.processing = false;

                coupon.editing = false;
                this.newCouponDialog = false;

                this.reloadCoupons();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
